
import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const challengesModule = angular
  .module('app.challenges', [])
  .config(challengesConfig);

challengesConfig.$inject = ['$routeProvider'];

function challengesConfig($routeProvider) {
  $routeProvider
    .when('/challenges-list', {
      template: '<ngz-challenges-list></ngz-challenges-list>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.CHALLENGE,
        breadcrumbs: [
          { label: 'Challenges', icon: NAVIGATION_ICON.ROCKET }
        ]
      }
    })
    .when('/challenge-create', {
      template: '<ngz-challenge-create></ngz-challenge-create>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.CHALLENGE,
        breadcrumbs: [
          { label: 'Challenge Create', icon: NAVIGATION_ICON.ROCKET }
        ]
      }
    })
    .when('/challenge-preview/:challengeId', {
      template: '<ngz-challenge-preview></ngz-challenge-preview>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/challenge-profile/:challengeId', {
      reloadOnSearch: false,
      template: '<ngz-challenge-profile></ngz-challenge-profile>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.CHALLENGE,
        breadcrumbs: [
          { label: 'Challenge Profile', icon: NAVIGATION_ICON.ROCKET }
        ]
      }
    })
    .when('/challenge-landing/:challengeId', {
      template: '<ngz-challenge-landing></ngz-challenge-landing>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/challenge-leaderboard/:challengeId', {
      template: '<ngz-challenge-leaderboard></ngz-challenge-leaderboard>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/challenge-sign-up/:challengeId', {
      template: '<ngz-challenge-sign-up></ngz-challenge-sign-up>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/nutrition-account-not-found', {
      template: '<ngz-nutrition-account-not-found></ngz-nutrition-account-not-found>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
    .when('/already-participant', {
      template: '<ngz-already-participant></ngz-already-participant>',
      pageConfig: {
        solution: null,
        hideNavigation: true,
      },
    })
  }
